import { Phone } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { GridCellEditStopParams, GridColDef, GridEventListener, GridRenderCellParams, GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { formatPhoneNumber } from 'common/utils';
import React from 'react';
import { FileLoader } from '../Loaders';
import { PhoneInput } from '../utils/PhoneInput';

const gridErrors: Map<string, string | undefined> = new Map;

type GridCellTypeProps = {
    [index: string]: (props: GridColDef) => Partial<GridColDef>;
};

const GridPhoneComponent = (props: GridRenderEditCellParams): React.ReactNode => {
    const [value, setValue] = React.useState(props.value ?? '');
    const { id, field } = props;

    const onCellEditStop: GridEventListener<"cellEditStop"> = (params: GridCellEditStopParams) => {
        if (params.id == props.id && params.field == props.field) {
            props.api?.setEditCellValue({ id, field, value });
        }
    };


    const cleanCallback = props.api?.subscribeEvent('cellEditStop', onCellEditStop);

    React.useEffect(() => {
        return () => {
            cleanCallback();
        };
    }, []);

    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return <PhoneInput
        fullWidth
        required
        label={'Numéro de téléphone'}
        value={value}
        defaultValue={props.value}
        onChange={(value: string | null) => {
            setValue(value ?? '');
        }}
        name="tel"
    />;
};

const FileItem = (props: { fileId: number, handleClose: () => void; }) => {

    const [url, setUrl] = React.useState('');

    return <MenuItem key={props.fileId} onClick={() => {
        if (url != '') {
            window.open(url, '_blank');
        }
        props.handleClose();
    }}><Typography variant='body2'><FileLoader id={props.fileId}>{model => {
        setUrl(model.url);
        return model.name;
    }}</FileLoader></Typography></MenuItem>;
};
const GridFilesComponent = <T extends { files?: number[]; },>(params: GridRenderEditCellParams<T>) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return params.row.files && params.row.files.length ? <div><Box
        component='a'
        sx={{ cursor: 'pointer' }}
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
    >
        {params.row.files.length + ' document(s)'}
    </Box>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >{params.row.files?.map(fileId => <FileItem key={fileId} fileId={fileId} handleClose={handleClose} />)}
        </Menu>
    </div> : null;
};

const gridCellType = {
    tel: (props: GridColDef): GridColDef => {
        return {
            ...props,
            renderCell: (params: GridRenderCellParams<any>) => {
                return params.value ? formatPhoneNumber(params.value) : '';
            },
            renderEditCell: (params: GridRenderEditCellParams) => {
                return <GridPhoneComponent {...params} />;
            }
        };
    }
};

const phoneColDef = (config: any, p: GridColDef): GridColDef => {
    return {
        ...baseColDef(config, p),
        renderCell: (params: GridRenderCellParams<any>) => {
            return params.value ? <><IconButton LinkComponent={'a'} target="_blank" size='small' href={`tel:${params.value}`}><Phone /></IconButton>{formatPhoneNumber(params.value)}</> : '';
        },
        renderEditCell: (params: GridRenderEditCellParams) => {
            return <GridPhoneComponent {...params} />;
        },
        ...p
    };
};
/*
const BaseRenderCell = (props: {renderCell?: (params: GridRenderCellParams<any>) => React.JSX.Element, params: GridRenderCellParams<any>}) => {
    const error = useSelector((state: AppState) => gridErrorSelector.selectById(state, props.params.row.id + ':' + props.params.field))
    return error ? <Tooltip title={error.msg}>{props?.renderCell(props.params) ?? <GridEditInputCell params={props.params} />}</Tooltip>: props?.renderCell(props.params) ?? <GridEditInputCell params={props.params} />
}
    */

const baseColDef = (config: any, p: GridColDef): GridColDef => {

    return {
        ...p,
        width: config?.[p.field]?.width ?? p.width ?? null,
    };
};


export default { gridCellType, GridFilesComponent, baseColDef, phoneColDef };
